import { createModel } from "hox";
import React, { useEffect, useState } from "react";
import { roleService } from "./RoleService";
import { TablePaginationConfig } from "antd/es/table/interface";
import { CheckInfo, EditModeType, IPgProps, ISearchPage, OptionDsType } from "@src/types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@utils/constants";
import { message } from "antd";
import { IMdRoleDetail, IMdRoleFields, IRoleGroup, IRoleColumnInsert } from "./RoleTypes";
import { menuService } from "../menu/MenuService";
import { IMdMenuDetail } from "../menu/MenuTypes";
import { resourceService } from "../resource/ResourceService";
import { IMdResourceDetail } from "../resource/ResourceTypes";
import { useUpdateEffect } from "ahooks";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}


function useModel() {

    const initSearchParam: IMdRoleFields = {};
    const initDataSource: IMdRoleDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdRoleFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdRoleDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedRowData, setSelectedRowData] = useState<IMdRoleDetail>();
    //列表数据源分页参数

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    /** Drawer */
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [resourceVisible, setResourceVisible] = useState(false);

    const [editModel, setEditModel] = useState<EditModeType>("add")
    const [editType, setEditType] = useState<'base' | 'menu' | 'column'>('base')

    const [resetState, setResetState] = useState(false)
    const [roleDs, setRoleDs] = useState<OptionDsType[]>()


    /** 菜单部分 */
    const [treeData, setTreeData] = useState<IMdMenuDetail[]>()
    const [checkMenu, setCheckMenu] = useState<CheckInfo<any>>()
    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
    const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);

    /** 资源部分 */
    const [indeterminate, setIndeterminate] = React.useState(true);
    const [checkAll, setCheckAll] = React.useState(false);
    const [resourceData, setResourceData] = useState<IMdResourceDetail[]>([])
    const [checkedResCodes, setCheckedResCodes] = React.useState<string[]>([]);
    const [checkedResDetail, setCheckedResDetail] = React.useState<IMdResourceDetail[]>([]);

    /** 可视化配置 */
    const [roleColumnData, setRoleColumnData] = useState<IRoleColumnInsert>();

    useEffect(() => {
        if (!drawerVisible) {
            setEditType("base")
            setCheckAll(false)
            setCheckMenu({})
            setCheckedResCodes([])
            setCheckedResDetail([])
            setCheckedKeys([])
            setIndeterminate(false)
            setSelectedKeys([])
            setResourceData([])
            setSelectedRowData(undefined)
        }
    }, [drawerVisible])

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        setChoosedBlock({})
        resetSearchParam()
        setResetState(!resetState)
    }

    /** 加载角色选择项 */
    const loadRoleList = async () => {
        const ds = await roleService.roleDs({})
        setRoleDs(ds)
    }
    /**
     * 根据应用code查找菜单树
     */
    const loadMenuTreeByRole = async (roleCode: string) => {
        const { retData } = await menuService.findTreeByRole(roleCode)
        setTreeData(retData)
    }

    /**
     * 加载全部菜单树
     */
    const loadMenuTreeAll = async () => {
        const data = await menuService.findTreeWithAllApp()
        console.log("all tree menu :", data)
        setTreeData(data)
    }


    /**
     * 根据应用和菜单查找资源树
     */
    const loadResourceByAppAndMenu = async (appCode: string, menuCode: string) => {
        const { retData } = await resourceService.findByAppAndMenu(appCode, menuCode)
        // setResourceData(retData.filter(item => item.status === 0))
        setResourceData(retData)
    }

    /**
     * 根据角色查找已配置资源
     */
    const loadResourceByRole = async (roleCode: string) => {
        const { retData } = await resourceService.findByRole(roleCode)
        setCheckedResDetail(retData)
        setCheckedResCodes(retData.map(item => item.code as string))
    }

    /**
     * 根据角色查找已配置菜单
     */
    const loadMenuListByRole = async (roleCode: string) => {
        const { retData } = await menuService.findMenuListByRole(roleCode)
        let menu = { checkedNodes: retData } as CheckInfo<IMdMenuDetail>
        setCheckMenu(menu)
        setCheckedKeys(retData.map(item => item.code as string))
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdRoleFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
    }

    const loadData = async (page?: ISearchPage, searchValue: IMdRoleFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            groupId: choosedBlock?.id || '',
            page: {
                // orders: [{
                //     asc: true,

                //     column: ""
                // }],
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await roleService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    const syncData = async () => {
        let ret = await roleService.sync(searchParam);
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        ret && await loadData()
    }



    //左边模块
    //区块
    const [blockList, setBlockList] = useState<IRoleGroup[]>([])
    const [choosedBlock, setChoosedBlock] = useState<IRoleGroup>({})
    const getBlockList = () => {
        roleService.roleGroupPage().then((res) => {
            setBlockList(res.retData.map(i => ({ ...i, isEdit: false })))
        })
    }
    useUpdateEffect(() => {
        onSearch()
    }, [choosedBlock])
    //添加一行
    const addBlock = () => {
        setTimeout(() => {
            const addData = { name: '', id: '', isEdit: true, temporaryId: Date.now() + Math.floor(Math.random() * 10000) }
            setBlockList([addData, ...blockList])
            setChoosedBlock(addData)
        }, 0)
    }
    const insertBlock = (data: any) => {
        roleService.roleGroupInsert(data).then((res) => {
            setChoosedBlock(res.retData)
            message.success('新增成功')
            getBlockList()
        })
    }
    const updateBlock = (data: any) => {
        roleService.roleGroupUpdate(data).then((res) => {
            message.success('更新成功')
            getBlockList()
        })
    }

    const deleteBlock = (data: any) => {
        const { id } = data
        if (id) {
            roleService.roleGroupRemove(id).then(() => {
                message.success('删除成功')
                getBlockList()
                setChoosedBlock({})
            })
        } else {
            setBlockList(blockList.filter((i) => i.id))
        }
    }


    const [userVisible, setUserVisible] = useState<boolean>(false)



    return {

        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedRowData,
        pgCfg,
        drawerVisible,
        resetState,
        resourceVisible,
        treeData,
        resourceData,
        indeterminate,
        selectedKeys,
        checkedResCodes,
        checkedResDetail,
        checkAll,
        checkedKeys,
        editModel,
        editType,
        checkMenu,
        roleDs,
        blockList,
        choosedBlock,
        userVisible,
        roleColumnData,

        /***method***/
        setDataSource,
        setSelectedRowKeys,
        setSelectedRowData,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        syncData,
        onSearch,
        onReset,
        setResourceVisible,
        loadMenuTreeByRole,
        loadMenuTreeAll,
        loadResourceByAppAndMenu,
        loadResourceByRole,
        setSelectedKeys,
        setIndeterminate,
        setCheckedResCodes,
        setCheckAll,
        loadMenuListByRole,
        setCheckedKeys,
        setEditModel,
        setEditType,
        setCheckMenu,
        loadRoleList,
        setResourceData,
        setCheckedResDetail,
        setChoosedBlock,
        setBlockList,
        getBlockList,
        addBlock,
        updateBlock,
        insertBlock,
        deleteBlock,
        setUserVisible,
        setRoleColumnData
    }

}


export const useRoleModel = createModel(useModel);